<script>
    import {emitPageViewEvent} from '../actions/pageAnalytics'
    export let location
    emitPageViewEvent(location,'About')
</script>
<div class="flex justify-center">
<div class="pageContent mt3 flex-auto">
    <div class="flex flex-column flex-auto">
        <h2>About</h2>
        <p class='flex-auto'>
            Post A Note was developed by David Han. <br>
            Follow me on Twitter: <a href='https://twitter.com/davjhan'>@davjhan</a>
        </p>
        <h2 class='mt1'>Contact</h2>
        <p class='flex-auto'>If you have any questions or concerns, send an email to</p>
        <span class='code self-center'>davjhan1@gmail.com</span>
        <h2 class='mt1'>Privacy Policy</h2>
        <p>
            This site uses Google Analytics.<br>
        </p>
        <h2 class='mt1'>Attribution</h2>
        <p >Icons on the home screen were made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
    </div>

</div>
</div>